import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import useMediaQuery from "@lib/useMediaQuery";
import { CSSProperties } from "react";
import { Carousel } from "react-responsive-carousel";
import { useWindowWidth } from "@react-hook/window-size";

const WhyUseLumiCarousel = ({ children, arrowTopPosition }) => {
  const renderIndicator = (
    clickHandler: (
      e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>
    ) => void,
    isSelected: boolean,
    index: number,
    label: string
  ) => (
    <li
      className={`mx-2 inline-block h-2 w-2 rounded-full ${
        isSelected ? "bg-primary" : "bg-primary4"
      }`}
      onClick={clickHandler}
      key={index}
      value={index}
      role="button"
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    />
  );

  const isBreakPoint = useMediaQuery(820);

  const arrowStyles: CSSProperties = {
    position: "absolute",
    zIndex: 2,
    top: `calc(${arrowTopPosition} - 15px)`,
    width: 35,
    height: 35,
    cursor: "pointer",
  };

  const width = useWindowWidth();

  return (
    <Carousel
      infiniteLoop
      showStatus={false}
      showThumbs={false}
      showArrows={true}
      preventMovementUntilSwipeScrollTolerance={true}
      swipeScrollTolerance={50}
      renderIndicator={renderIndicator}
      renderArrowPrev={(clickHandler, hasPrev) =>
        hasPrev && (
          <ChevronLeftIcon
            className="mr-2 items-center rounded-lg border p-1 text-primary2 transition-colors ease-linear"
            onClick={clickHandler}
            style={{
              ...arrowStyles,
              left: width > 570 ? "calc(45% - 15px)" : "calc(45% - 35px)",
            }}
          />
        )
      }
      renderArrowNext={(clickHandler, hasNext) =>
        hasNext && (
          <ChevronRightIcon
            className="ml-2 items-center rounded-lg border p-1 text-primary2 transition-colors ease-linear"
            onClick={clickHandler}
            style={{
              ...arrowStyles,
              right: width > 570 ? "calc(45% - 15px)" : "calc(45% - 35px)",
            }}
          />
        )
      }
      autoPlay
      interval={5000}
      centerMode={!isBreakPoint}
      centerSlidePercentage={33}
    >
      {children}
    </Carousel>
  );
};

export default WhyUseLumiCarousel;
